// Import dependencies
import { isEmpty } from '@automator/utilities';

// Get the strings of this utility
const strings = UncannyAutomatorBackend.i18n.utilities.relativeTime;

// Import dayjs and the plugins to get the relative time and translate the strings
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend( updateLocale );
dayjs.extend( relativeTime );

dayjs.updateLocale( 'en', {
	relativeTime: {
		future: strings.future,
		past: strings.past,
		m: strings.m,
		mm: strings.mm,
		h: strings.h,
		hh: strings.hh,
		d: strings.d,
		dd: strings.dd,
		M: strings.M,
		MM: strings.MM,
		y: strings.y,
		yy: strings.yy,
		s: number => number === 1 ? strings.s : strings.ss.replace( '%d', number )
	}
} );

/**
 * Get a relative time from the provided source.
 *
 * @param {"date"|"relative-seconds"} sourceType The type of the source. It can either be a date string or seconds relative from the current date.
 * @param {String|Number} source The source to get the relative time from. It can either be a date string or a number of seconds.
 * @return {String|undefined} The relative time from the source. Returns undefined if the sourceType or source is invalid.
 */
const getRelativeTime = ( sourceType, source ) => {
	// Check if the date is defined
	if ( isEmpty( source ) ) {
		throw new Error( `getRelativeTime: source can't be empty` );
	}

	let targetDate;

	switch ( sourceType ) {
		case 'date':
			targetDate = dayjs( source );
			break;

		case 'relative-seconds':
			targetDate = dayjs().add( source, 'second' );
			break;

		default:
			throw new Error( `getRelativeTime: Invalid sourceType. It must be either "date" or "relative-seconds"` );
	}

	// Check if it's a valid date
	if ( ! targetDate.isValid() ) {
		throw new Error( `getRelativeTime: Couldn't create a valid date` );
	}

	// Return relative date
	return targetDate.fromNow();
}

export default getRelativeTime;
